import { EmployeeRole } from '@/common/graphql';

export const EmployeeRoleLabels: Record<EmployeeRole, string> = {
  [EmployeeRole.Basic]: 'Basic',
  [EmployeeRole.Advanced]: 'Advanced',
  [EmployeeRole.AdminStandard]: 'Admin (Standard)',
  [EmployeeRole.AdminPrivate]: 'Admin (Private)',
  [EmployeeRole.SuperAdmin]: 'Super Admin',
};
